import PropTypes from "prop-types"
import { Alert, Avatar, Button } from "@mui/material"
import classNames from "classnames"
import { getErrorMessage } from "../../helpers"
import { ERROR_CODES, MESSAGE_ROLES } from "../../helpers/constants"
import { MESSAGE } from "../../helpers/shapes"
import { useAiTeammateContext } from "../../hooks/context"
import useFetchMessages from "../../hooks/fetch-messages"
import { useLastUserMessageText } from "../../hooks/selectors"
import AssistantIcon from "../icons/assistant"
import UserIcon from "../icons/user"
import PlotArtifact from "../plot-artifact"
import TableArtifact from "../table-artifact"
import MessageTime from "./messageTime"
import "./style.scss"

function AiTeammateMessage({ message, messageTimeRefresher }) {
  const { setUserMessageInputOverride, removeLastUserMessage } = useAiTeammateContext()
  const { role, text, createdAt, error, artifacts } = message
  const { fetchMessages } = useFetchMessages()
  const lastUserMessageText = useLastUserMessageText()

  const icon = role === MESSAGE_ROLES.USER ? <UserIcon /> : <AssistantIcon />

  function handleRetry() {
    setUserMessageInputOverride(lastUserMessageText)
  }

  function handleRefresh() {
    setUserMessageInputOverride(lastUserMessageText)
    removeLastUserMessage()
    fetchMessages()
  }

  let content = <div className="message-container">
    <div className="message-content">
      {text}

      {artifacts && artifacts.map(artifact => {
        switch (artifact.type) {
          case "table":
            return <TableArtifact key={artifact.id} artifact={artifact} />
          case "plot":
            return <PlotArtifact key={artifact.id} artifact={artifact} />
          default:
            return null
        }
      })}
    </div>
    {createdAt && <MessageTime date={createdAt} messageTimeRefresher={messageTimeRefresher} />}
  </div>

  if (error) {
    let action = <Button onClick={handleRetry}>Retry</Button>
    if (error.code === ERROR_CODES.CHAT_CONTINUE_THREAD_WITH_MESSAGE_CONFLICT) {
      action = <Button onClick={handleRefresh}>Refresh</Button>
    }

    content = <Alert severity="error" className="error-message" action={action}>
      {getErrorMessage(error)}
    </Alert>
  }

  return <>
    <div className={classNames("message", role, { error: !!error })}>
      {content}
      <Avatar className="message-avatar">
        {icon}
      </Avatar>
    </div>
  </>
}

AiTeammateMessage.propTypes = {
  message: MESSAGE.isRequired,
  messageTimeRefresher: PropTypes.number,
}

export default AiTeammateMessage
